import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import isNull from 'lodash/isNull';
import { PublishButton as PButton } from '../shared/styled-components';
import ModalDialog, { SaveButton, CloseButton } from '../../../../components/ModalDialog';
import {
  isValidPublishDate,
  getFormattedSchedule,
  LATER_PUBLISH_MINUTE_OFFSET,
} from '../../../../helpers/episodes';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';
import { ALERTS } from '../../../../helpers/texts';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import TimeListPicker from './TimeListPicker';

class PublishButton extends Component {
  constructor(props) {
    super(props);

    const alreadyScheduled = !isNull(props.publishOn);
    const publishOn = alreadyScheduled ? moment.unix(props.publishOn) : moment();

    this.state = {
      showModal: false,
      showDropdown: false,
      alreadyScheduled,
      pickedDate: moment(publishOn).startOf('day'),
      pickedTime: {
        hour: Number(moment(publishOn).format('HH')),
        minute: Number(moment(publishOn).format('mm')),
      },
    };

    this.timepicker;
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  toggleDropdownMenu = () => {
    const { showDropdown } = this.state;
    this.setState({
      showDropdown: !showDropdown,
    });
  };

  onSchedule = () => {
    const publishOn = this.getPublishOn();
    this.toggleModal();
    this.props.onPublishLater(publishOn);
  };

  onDatePick = pickedDate => {
    if (pickedDate.unix) {
      this.setState({
        pickedDate: moment(pickedDate).startOf('day'),
      });
    }
  };

  onTimePick = pickedTime => {
    this.setState({
      pickedTime,
    });
  };

  getPublishOn = () => {
    const {
      pickedDate,
      pickedTime: { hour, minute },
    } = this.state;

    return moment(pickedDate).add(hour, 'hour').add(minute, 'minute').unix();
  };

  publishNow = evt => {
    evt.preventDefault();
    this.props.onPublishNow();
  };

  rePublishNow = evt => {
    evt.preventDefault();
    this.props.onPublishNow({ rePublish: true });
  };

  publishLater = evt => {
    evt.preventDefault();
    this.toggleDropdownMenu();

    const { showModal } = this.props;
    if (!canUserAccessFeature('EPISODE_SCHEDULED')) {
      return showModal({
        title: 'Upgrade Required',
        content: ALERTS().EPISODE_SCHEDULED.NO_ACCESS,
        upgrade: true,
      });
    }

    this.toggleModal();
  };

  render() {
    const { disabled, hasPublishLater, hasRepublish } = this.props;
    const { alreadyScheduled, showModal, pickedDate, pickedTime } = this.state;
    const isInvalid = !isValidPublishDate(this.getPublishOn(), () => {
      return moment().add(LATER_PUBLISH_MINUTE_OFFSET, 'minute').endOf('minute');
    });

    const errormsg = isInvalid ? 'Publishing date cannot be in the past.' : '';

    return (
      <React.Fragment>
        <div className="btn-group">
          <PButton
            id="publish-btn"
            className="btn dropdown-toggle"
            onClick={this.publishNow}
            disabled={disabled}>
            Publish{!hasRepublish && ' Now'}
          </PButton>
        </div>
        {hasRepublish && (
          <div className="btn-group">
            <PButton
              id="publish-btn"
              className="btn dropdown-toggle"
              onClick={this.rePublishNow}
              title="Publication date will be changed!"
              disabled={disabled}>
              Republish Now
            </PButton>
          </div>
        )}
        {hasPublishLater && (
          <div className="btn-group">
            <PublishLater
              className="btn dropdown-toggle"
              onClick={this.publishLater}
              disabled={disabled}>
              Publish Later
            </PublishLater>
          </div>
        )}
        {hasPublishLater && alreadyScheduled && (
          <ScheduledOn className="text-medium">
            Scheduled for publication on{' '}
            <strong>{getFormattedSchedule(this.getPublishOn())}</strong>
          </ScheduledOn>
        )}

        <ModalDialog
          title="Pick Date & Time"
          open={showModal}
          bodyStyle={{ overflowY: 'auto' }}
          contentStyle={{
            width: 510,
            maxWidth: 'none',
            transform: 'translate(0px, 15px)',
          }}
          actions={[
            <CloseButton
              className="btn text-medium margin-two-right naked"
              onClick={this.toggleModal}>
              Cancel
            </CloseButton>,
            <SaveButton className="btn text-medium" onClick={this.onSchedule} disabled={isInvalid}>
              Publish Later
            </SaveButton>,
          ]}>
          <PickerWrapper>
            <DatePickerWrapper errored={isInvalid}>
              <div className="text-medium font-weight-600">Date</div>
              <span className="error-txt">{errormsg}</span>
              <DateTime
                open={true}
                value={pickedDate}
                timeFormat={false}
                onChange={this.onDatePick}
              />
            </DatePickerWrapper>
            <TimepickerWrapper errored={isInvalid}>
              <div className="text-medium font-weight-600">Time (24hr format)</div>
              <TimeListPicker
                pickedDate={pickedDate}
                pickedTime={pickedTime}
                onTimePick={this.onTimePick}
              />
            </TimepickerWrapper>
          </PickerWrapper>
        </ModalDialog>
      </React.Fragment>
    );
  }
}

const PickerWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const DatePickerWrapper = styled.div`
  width: 300px;
  min-width: 300px;
  position: relative;

  font-size: 14px;
  color: #474747;

  .rdt {
    input {
      ${props => (props.errored ? 'border: 1px solid #E57373 !important;' : '')}
    }

    .rdtPicker {
      width: 100%;
      td,
      th {
        height: 30px;
      }
    }
  }

  .error-txt {
    position: absolute;
    top: 55px;
    left: 1px;
    font-size: 1.3rem;
    color: #f44336;
  }
`;

const TimepickerWrapper = styled.div`
  width: 100%;
  margin-left: 20px;

  input {
    ${props => (props.errored ? 'border: 1px solid #E57373 !important;' : '')}
  }

  select {
    height: 214px;
    outline: 1px;
    padding: 2px;
    margin: 0px;
    color: #333;
    border: none;

    option {
      font-size: 1.4rem;
      padding: 5px 15px;
      cursor: pointer;
      text-align: center;

      &[disabled] {
        color: #cfcfcf;
        cursor: not-allowed;
      }
    }
  }
`;

const PublishLater = styled(PButton)`
  background-color: #369563;
`;

const ScheduledOn = styled.div`
  width: 160px;
  margin: 5px auto;
  font-size: 1.4rem;
`;

PublishButton.propTypes = {
  userInfo: PropTypes.object,
  publishOn: PropTypes.number,
  disabled: PropTypes.bool,
  hasPublishLater: PropTypes.bool,
  hasRepublish: PropTypes.bool,
  onPublishNow: PropTypes.func,
  onPublishLater: PropTypes.func,
  showModal: PropTypes.func,
};

PublishButton.defaultProps = {
  userInfo: {},
  publishOn: null,
  disabled: false,
  hasPublishLater: true,
  hasRepublish: false,
  onPublishNow: () => {},
  onPublishLater: () => {},
  showModal: () => {},
};

export default PublishButton;
